import React from 'react';
import { RiRobot2Fill } from 'react-icons/ri';

const AskWellnessBuddy = ({ onClick }) => {
    return (
        <button
            className='cursor-pointer flex items-center gap-2 mt-3 border border-solid border-black rounded-[0.5rem] p-2'
            onClick={onClick}
        >
            <RiRobot2Fill size={20} />
            Ask Wellness Buddy
        </button>
    );
};

export { AskWellnessBuddy };
